import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { TotemService } from '../totem.service';
@Component({
  selector: 'app-zonasinteres',
  templateUrl: './zonasinteres.component.html',
  styleUrls: ['./zonasinteres.component.css']
})
export class ZonasinteresComponent implements OnInit {
  id;
  idServicio;
  opcion;
  constructor(private route: ActivatedRoute, private totemService: TotemService) { }
  ngOnInit() {
    this.verificarruta();
  }

  verificarruta() {
    this.cancelartimer();
    this.route.paramMap.subscribe((observer: any) => {
      console.log('URL PARAMS: ', observer.params.id);
      const id = Number(observer.params.id);
      if (id === 1700 || id === 1701) {
        this.id = id;
        this.opcion = 'tiendas';
      } else if (id === 182) {
        this.idServicio = id;
        this.opcion = 'servicios';
      }
    });
  }
  // logica de reinicio
  scrollevent = (event: any): void => {
    this.cancelartimer();
  }
  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }

}
